import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/Inventory'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryStore",
			variables: true,
		})
	}
}

export async function load_Inventory(params) {
  await initClient()

	const store = new InventoryStore()

	await store.fetch(params)

	return {
		Inventory: store,
	}
}
